<template>
    <div class="number-container">
        <div class="number">{{showCount}}</div>
        <div class="text">{{title}}</div>
    </div>
</template>

<script>
    export default {
        name: "counter",
        props: {
            title: {
                type: String,
                default: "统计项",
            },
            count: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                maxCount: 0,
                showCount: 0,
                timer: null
            }
        },
        methods: {
            incCount: function () {
                let step = 2;
                if (this.maxCount > 100) {
                    step = parseInt(this.maxCount / 10)
                }
                this.timer = setInterval(() => {
                    if (this.showCount < this.maxCount) {
                        this.showCount += step;
                    } else {
                        this.showCount = this.maxCount
                        clearInterval(this.timer);
                    }
                }, 50);
            }
        },
        created: function () {
            this.maxCount = this.count;
            setTimeout(() => {
                this.incCount();
            }, 1500);
        }
    }
</script>

<style scoped lang="less">
    .number-container {
        display: inline-block;
        width: 100px;
        color: #fff;
        .number {
            font-size: 30px;
        }
        .text {
            font-size: 14px;
        }
    }
</style>